import React from 'react';
import { Grid, Typography } from '@mui/material';
import { t } from 'i18next';
import {
  GRAY_200,
  GRAY_500,
  GRAY_600,
  GRAY_700,
  GRAY_800,
} from '../../constants/Colors';

interface BakeasyLabelTextProps {
  label: string;
  value: string;
  required?: boolean;
  disabled?: boolean;
  maxLength?: number;
  style?: React.CSSProperties;
}

function BakeasyLabelText(props: BakeasyLabelTextProps) {
  return (
    <Grid>
      <Typography sx={{ fontWeight: 600, marginBottom: 0.25 }}>
        {t(props.label)}
      </Typography>
      <Typography>{props.value}</Typography>
    </Grid>
  );
}

export function BakeasyNotesLabelText(props: BakeasyLabelTextProps) {
  return (
    <Grid>
      <Typography
        sx={{
          fontSize: '0.95rem',
          fontWeight: 'bold',
          marginBottom: 0.25,
          color: GRAY_700,
        }}
      >
        {t(props.label)}
      </Typography>
      <Typography
        sx={{
          fontSize: '0.9rem',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        }}
      >
        {props.value}
      </Typography>
    </Grid>
  );
}

export default BakeasyLabelText;
